import { render, staticRenderFns } from "./collapse.vue?vue&type=template&id=49660c6d"
import script from "./collapse.vue?vue&type=script&lang=js"
export * from "./collapse.vue?vue&type=script&lang=js"
import style0 from "./collapse.vue?vue&type=style&index=0&id=49660c6d&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports